var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSetting = function SvgSetting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M1.332 8.587V7.413a1.27 1.27 0 0 1 1.267-1.266c1.206 0 1.7-.854 1.093-1.9-.347-.6-.14-1.38.467-1.727l1.153-.66a1.113 1.113 0 0 1 1.52.4l.073.127c.6 1.046 1.587 1.046 2.194 0l.073-.127a1.113 1.113 0 0 1 1.52-.4l1.153.66c.607.347.814 1.127.467 1.727-.607 1.046-.113 1.9 1.093 1.9a1.27 1.27 0 0 1 1.267 1.266v1.174a1.27 1.27 0 0 1-1.267 1.266c-1.206 0-1.7.854-1.093 1.9.347.607.14 1.38-.467 1.727l-1.153.66a1.113 1.113 0 0 1-1.52-.4l-.073-.127c-.6-1.046-1.587-1.046-2.194 0l-.073.127a1.113 1.113 0 0 1-1.52.4l-1.153-.66a1.266 1.266 0 0 1-.467-1.727c.607-1.046.113-1.9-1.093-1.9a1.27 1.27 0 0 1-1.267-1.266"
  })));
};
export default SvgSetting;